import styled from 'styled-components';

const H2 = styled.h2`
  width: 100%;
  padding: 0 1rem;
  color: white;
  margin: 0;
  font-family: 'Concert One';
`;

export default H2;
